import dayjs from 'dayjs';

  export const getEndTimeDayjs = (createdAt:string, timePeriod:number) => {
    return dayjs(createdAt).add(timePeriod, "minute");
  };

  
